import { FormRadiobuttonGroupProps } from './FormRadiobuttonGroup';
import { Theme, css } from '@emotion/react';

function getColorFromState(
  { fgDisabled, fgDangerBase }: Theme['colors'],
  disabled: boolean,
  error: boolean,
  fallback: string
) {
  if (error) {
    return fgDangerBase;
  }
  if (disabled) {
    return fgDisabled;
  }
  return fallback;
}

export const formRadioButtonGroupHorizontal = css`
  justify-content: center;
`;

export const formGroupRootStyles = ({ spacing, typography }: Theme) => css`
  margin-bottom: ${spacing(1)}px;
  & .MuiFormControlLabel-root {
    margin-left: ${typography.pxToRem(-8)};
  }
  & .MuiIconButton-root {
    padding: ${typography.pxToRem(6)};
  }
`;

export const formRadiobuttonGroupLabel =
  (disabled: FormRadiobuttonGroupProps['disabled'], hasHelperText?: boolean) =>
  ({ colors, spacing }: Theme) => css`
    margin-bottom: ${hasHelperText ? spacing(0.25) : spacing(0.5)}px;
    color: ${getColorFromState(colors, !!disabled, false, colors.fgDefault)};
  `;

export const formRadiobuttonGroupHelperText =
  (disabled: FormRadiobuttonGroupProps['disabled'], error: boolean) =>
  ({ spacing, colors }: Theme) => css`
    margin-bottom: ${spacing(0.25)}px;
    color: ${getColorFromState(colors, !!disabled, error, colors.fgSubtle)};
  `;
